import { PartnerEnquiry } from '../components/forms/PartnerEnquiry'

export default function DistributorEnquiryPage() {
  return <PartnerEnquiry kind="distributor" />
}
